import {Table} from "antd";
import React from "react";

const BatchDelTableComponent = ({dataSource, columns, rowSelection, rowKey}) => {
    return (
        <Table
            dataSource={dataSource}
            rowSelection={rowSelection}
            columns={columns}
            rowKey={rowKey}
            size="small"    // large | middle | small 对应不同的表格宽度
            // 表头冻结，纵向高度 550px
            scroll={{x: true, y: 550}}
            responsive={true}
            onChange={
                pagination => sessionStorage.setItem("currentPage", pagination.current.toString())
            }
            pagination={{
                defaultCurrent: parseInt(sessionStorage.getItem("currentPage")) || 1
            }}
        />
    );
};

export default BatchDelTableComponent;